import type { ICard } from "../../cardsSlice";

export const wandsData: ICard[] = [
{
    id: "wands_ace",
    arcana: "minor",
    suit: "wands",
    court: "simple",
    number: 1,
    name: "Туз Жезлов",
    nameEn: "Ace of Wands",

    keywords: ["Начало", "Энергия", "Вдохновение"],

    symbolism: [
      "Рука из облака держит жезл с зелёными ростками",
      "Холмы и замок вдали",
      "Ручей"
    ],
    symbolismInterpretation: "Творческая искра, начало пути, пробуждение жизненной силы",

    archetype: "Импульс к действию, пробуждение энергии",
    psychology: "Желание творить, ощущение силы начинать",

    upright: {
      personality: "Мотивация, энтузиазм",
      relationships: "Начало страстной связи",
      work: "Старт проекта, новый этап",
      spirituality: "Импульс роста",
      examples: ["Возможность, требующая действия", "Первый шаг к цели"]
    },
    reversed: {
      meaning: "Промедление, страх начинаний, пустые амбиции",
      nuances: "Энергия уходит в сторону, отсутствие реализации"
    },

    associations: ["Искра", "Росток", "Жара", "Порыв"],
    combinations: [
      "С Магом — мощное начало",
      "С Смертью — завершение цикла и старт нового"
    ],
    readingTips: [
      "Использовать шанс",
      "Действовать, не откладывая"
    ],
    selfQuestions: [
      "Что я хочу начать?",
      "Где во мне энергия, ждущая выхода?"
    ]
  },
{
    id: "wands_2",
    arcana: "minor",
    suit: "wands",
    court: "simple",
    number: 2,
    name: "Двойка Жезлов",
    nameEn: "Two of Wands",

    keywords: ["Планирование", "Выбор", "Перспектива"],

    symbolism: [
      "Человек с глобусом, опирающийся на жезл",
      "Крепостная стена",
      "Вид на воду"
    ],
    symbolismInterpretation: "Осмысление возможностей, предвкушение будущего",

    archetype: "Выбор пути, созерцание будущего",
    psychology: "Желание расширения горизонтов, сомнения между стабильностью и риском",

    upright: {
      personality: "Уверенность, обдуманность",
      relationships: "Совместное планирование",
      work: "Стратегия, подготовка",
      spirituality: "Осознание потенциала",
      examples: ["Выбор направления", "Видение будущего"]
    },
    reversed: {
      meaning: "Отсутствие решимости, страх перемен",
      nuances: "Нежелание выходить за пределы зоны комфорта"
    },

    associations: ["Путь", "Карта", "Наблюдение", "Проект"],
    combinations: [
      "С Тройкой Жезлов — переход от планирования к действию",
      "С Повешенным — застой в обдумывании"
    ],
    readingTips: [
      "Не затягивать с выбором",
      "Понимать, что план без действия мёртв"
    ],
    selfQuestions: [
      "Каким я вижу своё будущее?",
      "Что мешает сделать шаг?"
    ]
  },
{
    id: "wands_3",
    arcana: "minor",
    suit: "wands",
    court: "simple",
    number: 3,
    name: "Тройка Жезлов",
    nameEn: "Three of Wands",

    keywords: ["Перспектива", "Ожидание результатов", "Прогресс"],

    symbolism: [
      "Человек смотрит на корабли",
      "Три жезла",
      "Вода и холмы"
    ],
    symbolismInterpretation: "Начало реализации планов, видение будущих результатов",

    archetype: "Ожидание и надежда",
    psychology: "Уверенность в движении, вера в правильность пути",

    upright: {
      personality: "Дальновидность",
      relationships: "Перспективы развития",
      work: "Расширение, успех начинаний",
      spirituality: "Принятие пути",
      examples: ["Ожидание награды", "Контроль ситуации"]
    },
    reversed: {
      meaning: "Задержка результатов, сомнения в успехе",
      nuances: "Опасность упустить момент действия"
    },

    associations: ["Горизонт", "Путешествие", "Рост"],
    combinations: [
      "С Шестёркой Жезлов — триумф после ожидания",
      "С Колесницей — активное движение к цели"
    ],
    readingTips: [
      "Быть терпеливым",
      "Не упустить момент действия"
    ],
    selfQuestions: [
      "Чего я жду?",
      "Какие шаги укрепят мою позицию?"
    ]
  },
{
    id: "wands_4",
    arcana: "minor",
    suit: "wands",
    court: "simple",
    number: 4,
    name: "Четвёрка Жезлов",
    nameEn: "Four of Wands",

    keywords: ["Праздник", "Стабильность", "Завершение этапа"],

    symbolism: [
      "Арка из цветов",
      "Люди с букетами",
      "Замок на заднем плане"
    ],
    symbolismInterpretation: "Радость, достижение, торжество и ощущение дома",

    archetype: "Порог нового цикла, объединение и празднование",
    psychology: "Удовлетворение успехами, чувство принадлежности",

    upright: {
      personality: "Ощущение покоя, благодарности",
      relationships: "Гармония, семейное событие",
      work: "Завершение проекта, признание",
      spirituality: "Осознание смысла общих усилий",
      examples: ["Свадьба", "Новоселье", "Встреча с близкими"]
    },
    reversed: {
      meaning: "Несогласие, нестабильность, сложности в достижении согласия",
      nuances: "Временное нарушение гармонии"
    },

    associations: ["Арка", "Торжество", "Дом", "Союз"],
    combinations: [
      "С Десяткой Кубков — гармония в семье",
      "С Тузом Жезлов — старт нового счастливого цикла"
    ],
    readingTips: [
      "Замечать, что уже достигнуто",
      "Разделять радость с другими"
    ],
    selfQuestions: [
      "Что я могу отпраздновать?",
      "Где мой дом и поддержка?"
    ]
  },
{
    id: "wands_5",
    arcana: "minor",
    suit: "wands",
    court: "simple",
    number: 5,
    name: "Пятёрка Жезлов",
    nameEn: "Five of Wands",

    keywords: ["Соперничество", "Конфликт", "Конкуренция"],

    symbolism: [
      "Пятеро людей с поднятыми жезлами",
      "Хаотичные движения",
      "Отсутствие крови и агрессии"
    ],
    symbolismInterpretation: "Борьба интересов, тренировка, проверка сил",

    archetype: "Испытание стойкости, конфликт ради роста",
    psychology: "Столкновение с вызовами, прояснение границ",

    upright: {
      personality: "Активность, борьба за место",
      relationships: "Разногласия, конкуренция",
      work: "Соперничество в коллективе",
      spirituality: "Обучение через конфликт",
      examples: ["Тренировка", "Отстаивание позиции"]
    },
    reversed: {
      meaning: "Бесплодные споры, избегание конфликта",
      nuances: "Энергия уходит в пустую борьбу"
    },

    associations: ["Спор", "Борьба", "Тренировка"],
    combinations: [
      "С Семёркой Жезлов — необходимость отстаивать позиции",
      "С Десяткой Мечей — конфликт, ведущий к поражению"
    ],
    readingTips: [
      "Не терять энергии впустую",
      "Искать конструктивный выход"
    ],
    selfQuestions: [
      "За что я борюсь?",
      "Какие конфликты можно превратить в рост?"
    ]
  },
{
    id: "wands_6",
    arcana: "minor",
    suit: "wands",
    court: "simple",
    number: 6,
    name: "Шестёрка Жезлов",
    nameEn: "Six of Wands",

    keywords: ["Победа", "Признание", "Успех"],

    symbolism: [
      "Всадник с венком на жезле",
      "Толпа приветствует его",
      "Белый конь"
    ],
    symbolismInterpretation: "Общественное признание, достижение цели, триумф",

    archetype: "Торжество победителя, возвращение с триумфом",
    psychology: "Подъём уверенности, радость признания",

    upright: {
      personality: "Гордость, лидерство",
      relationships: "Успех совместных усилий",
      work: "Награда, признание заслуг",
      spirituality: "Подтверждение ценности пути",
      examples: ["Триумф", "Завершение важного дела"]
    },
    reversed: {
      meaning: "Зависть, сомнения в успехе, отсутствие поддержки",
      nuances: "Сложности с принятием признания"
    },

    associations: ["Венок", "Белый конь", "Аплодисменты"],
    combinations: [
      "С Тузом Жезлов — успех нового начинания",
      "С Пятёркой Жезлов — победа после борьбы"
    ],
    readingTips: [
      "Принимать признание с благодарностью",
      "Оставаться скромным"
    ],
    selfQuestions: [
      "Что я считаю победой?",
      "С кем могу разделить радость?"
    ]
  },
{
    id: "wands_7",
    arcana: "minor",
    suit: "wands",
    court: "simple",
    number: 7,
    name: "Семёрка Жезлов",
    nameEn: "Seven of Wands",

    keywords: ["Отстаивание позиции", "Вызов"],

    symbolism: [
      "Человек с жезлом отражает нападки снизу",
      "Неустойчивое положение",
      "Решимость в позе"
    ],
    symbolismInterpretation: "Защита своей территории, стойкость под давлением",

    archetype: "Защитник, воин, стоящий на своём",
    psychology: "Готовность бороться за себя, осознание ценности позиции",

    upright: {
      personality: "Решимость, упорство",
      relationships: "Необходимость отстаивать взгляды",
      work: "Конкуренция, давление",
      spirituality: "Проверка силы духа",
      examples: ["Сопротивление", "Преодоление трудностей"]
    },
    reversed: {
      meaning: "Уступки, слабость, потеря позиции",
      nuances: "Сдача без борьбы"
    },

    associations: ["Оборона", "Давление", "Противостояние"],
    combinations: [
      "С Колесницей — активная защита интересов",
      "С Девяткой Жезлов — длительная борьба"
    ],
    readingTips: [
      "Не сдаваться при первых трудностях",
      "Чётко обозначать границы"
    ],
    selfQuestions: [
      "За что мне важно бороться?",
      "Где моя точка опоры в спорах?"
    ]
  },
{
    id: "wands_8",
    arcana: "minor",
    suit: "wands",
    court: "simple",
    number: 8,
    name: "Восьмёрка Жезлов",
    nameEn: "Eight of Wands",

    keywords: ["Скорость", "Движение", "Прогресс"],

    symbolism: [
      "Восемь жезлов летят по воздуху",
      "Голубое небо",
      "Зелёный пейзаж"
    ],
    symbolismInterpretation: "Быстрое развитие событий, ускоренный процесс",

    archetype: "Поток изменений, стремительное развитие",
    psychology: "Сосредоточенность на цели, освобождение энергии",

    upright: {
      personality: "Ясность, решительность",
      relationships: "Быстрое сближение, новости",
      work: "Ускорение дел, успешное завершение",
      spirituality: "Понимание хода событий",
      examples: ["Переезды", "Новости", "Интенсивное развитие"]
    },
    reversed: {
      meaning: "Задержки, путаница, напрасная спешка",
      nuances: "Неверный выбор направления"
    },

    associations: ["Полёт", "Вестник", "Скорость", "Открытость"],
    combinations: [
      "С Колесницей — максимально быстрое продвижение",
      "С Повешенным — внезапный прорыв после паузы"
    ],
    readingTips: [
      "Использовать момент",
      "Не терять фокус"
    ],
    selfQuestions: [
      "Куда направлена моя энергия?",
      "Как я справляюсь со скоростью событий?"
    ]
  },
{
    id: "wands_9",
    arcana: "minor",
    suit: "wands",
    court: "simple",
    number: 9,
    name: "Девятка Жезлов",
    nameEn: "Nine of Wands",

    keywords: ["Выносливость", "Защита", "Настороженность"],

    symbolism: [
      "Человек с перевязанной головой держит жезл",
      "Восемь жезлов позади",
      "Напряжённая поза"
    ],
    symbolismInterpretation: "Подготовка к новым вызовам после прошлых испытаний",

    archetype: "Бдительный защитник, опытный воин",
    psychology: "Повышенная осторожность, готовность к обороне",

    upright: {
      personality: "Выдержка, осторожность",
      relationships: "Осторожность после ран",
      work: "Защита достигнутого",
      spirituality: "Сохранение позиции через внутреннюю силу",
      examples: ["Подготовка", "Настороженность", "Продолжение борьбы"]
    },
    reversed: {
      meaning: "Паранойя, усталость, отказ продолжать",
      nuances: "Потеря веры в результат"
    },

    associations: ["Стережёт", "Опыт", "Бдительность"],
    combinations: [
      "С Семёркой Жезлов — длительная оборона",
      "С Четвёркой Мечей — вынужденный отдых"
    ],
    readingTips: [
      "Сохранять баланс между бдительностью и доверием",
      "Не перегореть"
    ],
    selfQuestions: [
      "От чего я защищаюсь?",
      "Где мои страхи оправданы, а где нет?"
    ]
  },
{
    id: "wands_10",
    arcana: "minor",
    suit: "wands",
    court: "simple",
    number: 10,
    name: "Десятка Жезлов",
    nameEn: "Ten of Wands",

    keywords: ["Бремя", "Ответственность", "Тяжесть"],

    symbolism: [
      "Человек несёт десять жезлов",
      "Согнутая спина",
      "Деревня впереди"
    ],
    symbolismInterpretation: "Чрезмерная нагрузка, работа на пределе сил",

    archetype: "Труженик, несущий ношу",
    psychology: "Стремление довести начатое до конца, несмотря на усталость",

    upright: {
      personality: "Ответственность, упорство",
      relationships: "Тяжёлые обязательства",
      work: "Перегрузка, завершение задачи",
      spirituality: "Прохождение испытания до конца",
      examples: ["Перегрузка", "Долг", "Финальный рывок"]
    },
    reversed: {
      meaning: "Сброс лишней нагрузки, отказ от обязанностей",
      nuances: "Неумение делегировать"
    },

    associations: ["Ноша", "Долг", "Сдача"],
    combinations: [
      "С Восьмёркой Пентаклей — упорная работа",
      "С Башней — вынужденный сброс обязанностей"
    ],
    readingTips: [
      "Оценить, всё ли я должен нести сам",
      "Учиться делегировать"
    ],
    selfQuestions: [
      "Что я несу и зачем?",
      "Можно ли разделить нагрузку?"
    ]
  },
{
    id: "wands_11",
    arcana: "minor",
    suit: "wands",
    court: "page",
    number: 11,
    name: "Паж Жезлов",
    nameEn: "Page of Wands",

    keywords: ["Любопытство", "Начало пути", "Вдохновение"],

    symbolism: [
      "Молодой человек с жезлом в пустыне",
      "Оранжевая одежда",
      "Взгляд вверх"
    ],
    symbolismInterpretation: "Исследование новых возможностей, юношеская энергия",

    archetype: "Посланник, ученик",
    psychology: "Открытость к новому, жажда знаний",

    upright: {
      personality: "Энтузиазм, инициатива",
      relationships: "Начало общения",
      work: "Новый проект, обучение",
      spirituality: "Поиск вдохновения",
      examples: ["Начало путешествия", "Получение вести", "Проба сил"]
    },
    reversed: {
      meaning: "Нерешительность, инфантильность",
      nuances: "Отсутствие планов"
    },

    associations: ["Пустыня", "Весть", "Начало"],
    combinations: [
      "С Тузом Жезлов — сильное начало",
      "С Пажом Кубков — эмоционально вдохновляющее известие"
    ],
    readingTips: [
      "Оставаться открытым к новому",
      "Использовать любопытство как ресурс"
    ],
    selfQuestions: [
      "Что нового я готов изучить?",
      "Какие возможности я вижу?"
    ]
  },
{
    id: "wands_12",
    arcana: "minor",
    suit: "wands",
    court: "knight",
    number: 12,
    name: "Рыцарь Жезлов",
    nameEn: "Knight of Wands",

    keywords: ["Движение", "Риск", "Приключение"],

    symbolism: [
      "Всадник в оранжевых доспехах",
      "Жезл в руке",
      "Песчаный пейзаж"
    ],
    symbolismInterpretation: "Энергия перемен, стремление вперёд",

    archetype: "Искатель приключений",
    psychology: "Импульсивность, страсть к новому",

    upright: {
      personality: "Энергичность, смелость",
      relationships: "Бурное развитие",
      work: "Командировка, резкие перемены",
      spirituality: "Стремление к расширению горизонтов",
      examples: ["Переезд", "Приключение", "Быстрые решения"]
    },
    reversed: {
      meaning: "Необдуманность, хаотичность",
      nuances: "Риск без подготовки"
    },

    associations: ["Песок", "Порыв", "Путь"],
    combinations: [
      "С Колесницей — очень быстрое движение",
      "С Луной — риск заблудиться"
    ],
    readingTips: [
      "Сохранять баланс между скоростью и планом",
      "Не сжигать мосты"
    ],
    selfQuestions: [
      "Куда я спешу?",
      "Как я отношусь к риску?"
    ]
  },
{
    id: "wands_13",
    arcana: "minor",
    suit: "wands",
    court: "queen",
    number: 13,
    name: "Королева Жезлов",
    nameEn: "Queen of Wands",

    keywords: ["Харизма", "Энергия", "Теплота"],

    symbolism: [
      "Женщина с жезлом и подсолнухом",
      "Чёрная кошка у ног",
      "Яркий трон"
    ],
    symbolismInterpretation: "Лидерство с теплотой и обаянием",

    archetype: "Хозяйка энергии, вдохновляющая личность",
    psychology: "Уверенность в себе, позитивный настрой",

    upright: {
      personality: "Обаяние, решительность",
      relationships: "Страсть, теплая связь",
      work: "Креативное лидерство",
      spirituality: "Яркое выражение себя",
      examples: ["Поддержка", "Творческое вдохновение"]
    },
    reversed: {
      meaning: "Манипуляция, ревность",
      nuances: "Излишний контроль"
    },

    associations: ["Кошка", "Солнце", "Огонь"],
    combinations: [
      "С Императрицей — сильная женская энергия",
      "С Магом — лидерство в проекте"
    ],
    readingTips: [
      "Доверять своей харизме",
      "Не злоупотреблять влиянием"
    ],
    selfQuestions: [
      "Как я вдохновляю других?",
      "Где я могу проявить лидерство?"
    ]
  },
{
    id: "wands_14",
    arcana: "minor",
    suit: "wands",
    court: "king",
    number: 14,
    name: "Король Жезлов",
    nameEn: "King of Wands",

    keywords: ["Видение", "Лидерство", "Опыт"],

    symbolism: [
      "Мужчина с жезлом на троне",
      "Саламандры на одежде",
      "Пустынный фон"
    ],
    symbolismInterpretation: "Видение и умение вдохновить на достижение целей",

    archetype: "Мудрый лидер, стратег",
    psychology: "Сочетание опыта и страсти к делу",

    upright: {
      personality: "Решимость, дальновидность",
      relationships: "Надёжный партнёр",
      work: "Стратегия, управление",
      spirituality: "Уверенное следование пути",
      examples: ["Руководство", "Поддержка", "Вдохновение"]
    },
    reversed: {
      meaning: "Деспотизм, упрямство",
      nuances: "Использование власти в личных целях"
    },

    associations: ["Огонь", "Саламандры", "Трон"],
    combinations: [
      "С Королевой Жезлов — гармоничное партнёрство",
      "С Тузом Мечей — решительные действия"
    ],
    readingTips: [
      "Сохранять баланс между властью и уважением",
      "Делегировать полномочия"
    ],
    selfQuestions: [
      "Как я веду за собой?",
      "Какие цели вдохновляют меня?"
    ]
  }
];


